import moment from 'moment';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { formatSecondsObject } from '@playbookux/playbook-web-core';

import {
  Container,
  Timer,
  Title,
} from './styles';

const FORMAT = 'YYYY-MM-DD HH:mm:ss';

const TimerComponent = (props) => {
  /** props */
  const {
    title,
    time,
    onSetExpired,
  } = props;

  /** states */
  const [timeRemaining, setTimeRemaining] = React.useState();
  const [intervalId, setIntervalId] = React.useState();

  const buildTimeRemaining = () => {
    // Get the minutes remaining between the expiration time and current time

    const expiration = moment(time, FORMAT);
    const now = moment.utc().format(FORMAT);
    const remaining = expiration.diff(now);

    const timeRemainingFormatted = moment.duration(remaining).asSeconds();
    setTimeRemaining(timeRemainingFormatted);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      buildTimeRemaining();
    }, 1000);

    setIntervalId(interval);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (timeRemaining <= 0 && intervalId) {
      clearInterval(intervalId);
      setTimeRemaining(0);
      setIntervalId(null);
      onSetExpired(true);
    }
  }, [intervalId, onSetExpired, timeRemaining]);

  const { minutes, seconds } = formatSecondsObject(timeRemaining || 0);

  return (
    <Container>
      <Title>{title}</Title>
      <Timer>{`${minutes} minutes ${seconds} seconds`}</Timer>
    </Container>
  );
};

TimerComponent.propTypes = {
  title: PropTypes.string,
  time: PropTypes.number,
  onSetExpired: PropTypes.func.isRequired,
};

TimerComponent.defaultProps = {
  title: 'Please start the study within: ',
  time: 1,
};

export default TimerComponent;
